import React, { useState, useEffect } from 'react';

const Toast = ({ 
  message, 
  type = 'info', 
  duration = 4000, 
  onClose, 
  show = true,
  position = 'top-right',
  onConfirm,
  onCancel
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);

      // Solo auto-hide si no es una confirmación
      if (type !== 'confirm' && duration > 0) {
        const autoHideTimer = setTimeout(() => {
          if (!isHovered) {
            handleClose();
          }
        }, duration);

        return () => {
          clearTimeout(timer);
          clearTimeout(autoHideTimer);
        };
      }

      return () => {
        clearTimeout(timer);
      };
    }
  }, [show, duration, isHovered, type]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  const getToastStyles = () => {
    const baseStyles = {
      position: 'fixed',
      zIndex: 9999,
      minWidth: '300px',
      maxWidth: '400px',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      color: '#fff',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
      opacity: 0,
      cursor: 'pointer'
    };

    if (isVisible) {
      baseStyles.transform = 'translateX(0)';
      baseStyles.opacity = '1';
    }

    // Posición
    switch (position) {
      case 'top-right':
        baseStyles.top = '20px';
        baseStyles.right = '20px';
        break;
      case 'top-left':
        baseStyles.top = '20px';
        baseStyles.left = '20px';
        baseStyles.transform = 'translateX(-100%)';
        if (isVisible) baseStyles.transform = 'translateX(0)';
        break;
      case 'bottom-right':
        baseStyles.bottom = '20px';
        baseStyles.right = '20px';
        break;
      case 'bottom-left':
        baseStyles.bottom = '20px';
        baseStyles.left = '20px';
        baseStyles.transform = 'translateX(-100%)';
        if (isVisible) baseStyles.transform = 'translateX(0)';
        break;
      case 'center':
        baseStyles.top = '50%';
        baseStyles.left = '50%';
        baseStyles.transform = 'translate(-50%, -50%)';
        baseStyles.minWidth = '350px';
        break;
    }

    // Colores por tipo
    const typeColors = {
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      confirm: '#6f42c1'
    };

    baseStyles.backgroundColor = typeColors[type] || typeColors.info;

    return baseStyles;
  };

  const getIcon = () => {
    const icons = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️',
      confirm: '❓'
    };
    return icons[type] || icons.info;
  };

  if (type === 'confirm') {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000
      }}>
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#333'
          }}>
            {message}
          </div>
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center'
          }}>
            <button
              onClick={onCancel}
              style={{
                padding: '8px 20px',
                border: '1px solid #dc3545',
                borderRadius: '6px',
                backgroundColor: '#fff',
                color: '#dc3545',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              style={{
                padding: '8px 20px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#28a745',
                color: '#fff',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={getToastStyles()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClose}
    >
      <span style={{ fontSize: '16px' }}>{getIcon()}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }}
        style={{
          background: 'none',
          border: 'none',
          color: '#fff',
          fontSize: '18px',
          cursor: 'pointer',
          padding: '0',
          marginLeft: '8px'
        }}
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
